import { render, staticRenderFns } from "./HomeSalesChannels.vue?vue&type=template&id=69a34e43&scoped=true&"
import script from "./HomeSalesChannels.vue?vue&type=script&lang=js&"
export * from "./HomeSalesChannels.vue?vue&type=script&lang=js&"
import style0 from "./HomeSalesChannels.vue?vue&type=style&index=0&id=69a34e43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a34e43",
  null
  
)

export default component.exports